import './style.css'

const Header = () => {
    return ( 
        <header>
            <h2>Meme Generator</h2>
        </header>
     );
}
 
export default Header;